package com.qrkontaq.ui.sections.projects.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.theme.AppColors
import com.qrkontaq.ui.theme.AppTypography
import com.qrkontaq.ui.utils.responsiveBorderRadius
import com.qrkontaq.ui.utils.responsiveFontSize
import com.qrkontaq.ui.utils.responsiveHeight
import com.qrkontaq.ui.utils.responsivePadding
import com.qrkontaq.ui.utils.responsiveWidth
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

val ProjectCardStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("transform", 300.ms, AnimationTimingFunction.EaseInOut),
                Transition.of("box-shadow", 300.ms, AnimationTimingFunction.EaseInOut)
            )
    }
    hover {
        Modifier
            .translateY((-8).px)
            .styleModifier {
                property("box-shadow", "0 16px 40px rgba(0, 0, 0, 0.25)")
            }
    }
}

@Composable
internal fun ProjectCard(
    title: String,
    category: String,
    description: String
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        ProjectCardStyle
            .toModifier()
            .responsiveBorderRadius(16)
            .overflow(Overflow.Hidden)
            .backgroundColor(colors.surfaceVariant)
            .responsiveWidth(350, minMultiplier = 0.8, maxMultiplier = 1.0)
            .responsiveHeight(300, minMultiplier = 0.9, maxMultiplier = 1.1)
    ) {
        Column(
            Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.SpaceBetween
        ) {

            Box(
                Modifier
                    .fillMaxWidth()
                    .responsiveHeight(200)
                    .backgroundColor(colors.border),
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    "🖼️",
                    Modifier.responsiveFontSize(64).opacity(0.3)
                )
            }

            Column(
                Modifier
                    .fillMaxWidth()
                    .responsivePadding(24, 24)
                    .styleModifier { property("gap", "0.5rem") }
            ) {
                SpanText(
                    category.uppercase(),
                    Modifier
                        .responsiveFontSize(12)
                        .fontWeight(FontWeight.Bold)
                        .color(AppColors.Primary)
                        .letterSpacing(0.1.em)
                )

                SpanText(
                    title,
                    Modifier
                        .responsiveFontSize(21)
                        .fontWeight(FontWeight.Bold)
                        .color(colors.textPrimary)
                        .fontFamily(AppTypography.SECONDARY_FONT_NAME, AppTypography.SECONDARY_FONT_FALLBACK)
                )

                SpanText(
                    description,
                    Modifier
                        .responsiveFontSize(14)
                        .color(colors.textSecondary)
                        .lineHeight(1.5)
                )
            }
        }
    }
}
